const en = {
  "comingSoon": "Coming soon",
  "soonSub": "New troll hunt",
  "follow": "Follow us for news",
  "playNow": "Play the Fjord Trail now",
  "prev": "Previous trail",
  "next": "Next trail",
  "of": "of",
  "readMore": "Read about the trail",
  "otherTrails": "More trails on the way",
  "partner": {
    "kicker": "For businesses & municipalities",
    "badge": "For businesses",
    "title": "Partner with Trollfossjakten.",
    "pitch": "Hotels, cafés, saunas, ski resorts and whole municipalities can put their own trolls on the map. The hunt leads families and tourists straight to your door — all year round.",
    "points": [
      "Your place pinned on the troll map",
      "Guests pre-order and pay with Vipps",
      "Launch price: 50% off for the first 50"
    ],
    "cta": "Become a partner",
    "cta2": "For businesses",
    "pin": "Your business here",
    "stamp": "50% off"
  },
  "names": {
    "partner": "Partner with us",
    "fjord": "The Fjord Trail",
    "stairs": "Midnattsoltrappa",
    "farm": "The Ågård Trolls",
    "forest": "The Forest Path",
    "sea": "The Sea Troll Route"
  },
  "slides": {
    "stairs": {
      "kicker": "Spansdalen · Lavangen",
      "title": "Midnattsoltrappa: 20 trolls on 2,117 steps.",
      "pitch": "A wooden staircase straight up the mountainside at Spanstind / Ruŋgugáisá — 380 metres of climbing with views over Spansdalen and the Lavangen fjord. Twenty trolls wait on the steps, on the viewing platform and by the Henrikka waterfall.",
      "stats": [
        [
          "20",
          "trolls"
        ],
        [
          "2117",
          "steps"
        ],
        [
          "380",
          "metres up"
        ]
      ],
      "note": "Best under the midnight sun in June and July."
    },
    "farm": {
      "kicker": "Lavangen · Troms",
      "title": "The Ågård Trolls: 30 trolls on the other side of the valley.",
      "pitch": "A brand-new stretch of road on the far side of the valley, past red farmhouses, hay racks, grazing sheep and the shore. Farm trolls in knitted caps hide behind fences and milk churns.",
      "stats": [
        [
          "30",
          "trolls"
        ],
        [
          "1",
          "new road"
        ],
        [
          "4",
          "seasons"
        ]
      ],
      "note": "A whole new road — and a whole new crowd of trolls."
    },
    "forest": {
      "kicker": "Lavangen · Gratangen",
      "title": "The Forest Path: 25 trolls among birch and pine.",
      "pitch": "A narrow path through mossy birch and pine forest, past bogs full of cotton grass, babbling brooks and little footbridges. Moss trolls in mushroom hats peek out from behind trunks and boulders.",
      "stats": [
        [
          "25",
          "trolls"
        ],
        [
          "1",
          "forest path"
        ],
        [
          "4",
          "seasons"
        ]
      ],
      "note": "Bring your camera — and some chocolate."
    },
    "sea": {
      "kicker": "Gratangen · Lavangen · Sjøvegan",
      "title": "The Sea Troll Route: catch the Kraken and the giant turtle.",
      "pitch": "A boat route on the fjord from Gratangen via Lavangen to Sjøvegan. Beneath the surface wait sea trolls and two 45-metre giants — the Kraken and the ancient giant turtle with a whole islet on its back.",
      "stats": [
        [
          "15",
          "sea trolls"
        ],
        [
          "45 m",
          "long giants"
        ],
        [
          "3",
          "harbours"
        ]
      ],
      "note": "A special boat package for paying guests."
    }
  }
};

export default en;
